import { useCallback, useContext, useMemo } from 'react';
import { useParams } from 'react-router';

import { getDeepLink } from 'src/modules/homeownerApp/constants/scans';
import {
  HomeownerAppMenuNames,
  homeownerAppContext,
} from 'src/modules/homeownerApp/providers/HomeownerAppProvider';
import { useIsMobileSize } from 'src/modules/renderings/hooks';

export const useGetAppLink = () => {
  const { setCurrentMenu } = useContext(homeownerAppContext);
  const { projectId } = useParams<{ projectId: string }>();
  const deepLink = getDeepLink(projectId);
  const isMobile = useIsMobileSize();

  const onGetAppClick = useCallback(() => {
    if (isMobile) {
      window.open(deepLink, '_blank');
    } else {
      setCurrentMenu(HomeownerAppMenuNames.DOWNLOAD_APP);
    }
  }, [deepLink, isMobile, setCurrentMenu]);

  return useMemo(() => ({ onGetAppClick }), [onGetAppClick]);
};
